<template>
  <div>
    <v-card class="pa-4 base-card z-10">
      <v-row v-show="showFilter">
        <v-col cols="6">
          <UITextField
            v-model="filters.name"
            placeholder="Наименование события"
            return-object hide-details
            @input="setFilters"
          />
        </v-col>

        <v-col cols="6">
          <UITextField
            v-model="filters.lector"
            placeholder="Лектор"
            return-object hide-details
            @input="setFilters"
          />
        </v-col>

        <v-col cols="4">
          <UIAutocomplete
            v-model="filters.eventPartType"
            placeholder="Тип события"
            :items="eventPartTypeDirectory" item-text="name"
            return-object hide-details
            @input="setFilters"
          />
        </v-col>

        <v-col cols="4">
          <UIAutocomplete
            v-model="filters.location"
            placeholder="Площадка"
            :items="locationDirectory" item-text="name"
            return-object hide-details
            @input="setFilters"
          />
        </v-col>

        <v-col cols="4">
          <UITextField
            v-model="filters.theme"
            placeholder="Тема"
            return-object hide-details
            @input="setFilters"
          />
        </v-col>

        <v-col cols="3">
          <UIDatePickerMenu
            v-model="filters.dateFrom"
            placeholder="Дата начала"
            return-object hide-details
            @input="setFilters"
          />
        </v-col>

        <v-col cols="3">
          <UITextField
            v-model="filters.timeFrom"
            v-mask="'##:##'"
            placeholder="Время начала"
            return-object hide-details
            @input="setFilters"
          />
        </v-col>

        <v-col cols="3">
          <UIDatePickerMenu
            v-model="filters.dateTo"
            placeholder="Дата окончания"
            return-object hide-details
            @input="setFilters"
          />
        </v-col>

        <v-col cols="3">
          <UITextField
            v-model="filters.timeTo"
            v-mask="'##:##'"
            placeholder="Время окончания"
            return-object hide-details
            @input="setFilters"
          />
        </v-col>
      </v-row>

      <FilterChips
        v-show="!showFilter"
        :chips="filterChips"
        @resetFilter="resetFilter"
      />
    </v-card>
  </div>
</template>

<script>
import { EventPartFilters } from '@/models'
import FilterChips from '@/ui/FilterChips'
import UIAutocomplete from '@/ui/input/UIAutocomplete'
import UITextField from '@/ui/input/UITextField'
import UIDatePickerMenu from '@/ui/input/UIDatePickerMenu'
import {
  mapActions,
  mapGetters,
} from 'vuex'

export default {
  name: 'EventPartFilter',

  components: {
    UIDatePickerMenu,
    UITextField,
    UIAutocomplete,
    FilterChips,
  },

  props: {
    showFilter: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    eventPartType: [],
    location: [],

    filters: new EventPartFilters(),

    searchFIO: '',
  }),

  computed: {
    ...mapGetters('directories', ['locationDirectory', 'eventPartTypeDirectory']),

    filterChips() {
      const arr = []
      const filters = this.filters.getNormalData()
      Object.keys(filters).forEach((key) => {
        switch (key) {
          case 'name':
            filters[key] && arr.push({ visible: true, key: 'name', name: 'Наименование события', value: filters[key] })
            break
          case 'dateTimeFrom':
            filters[key] && arr.push({ visible: true, key: 'dateTimeFrom', name: 'Дата начала', value: filters[key] })
            break
          case 'dateTimeTo':
            filters[key] && arr.push({ visible: true, key: 'dateTimeTo', name: 'Дата окончания', value: filters[key] })
            break
          case 'eventPartType':
            filters[key] && arr.push({ visible: true, key: 'eventPartType', name: 'Тип события', value: filters[key].name })
            break
          case 'lector':
            filters[key] && arr.push({ visible: true, key: 'lector', name: 'Лектор', value: filters[key] })
            break
          case 'location':
            filters[key] && arr.push({ visible: true, key: 'location', name: 'Площадка', value: filters[key].name })
            break
          case 'theme':
            filters[key] && arr.push({ visible: true, key: 'theme', name: 'Тема', value: filters[key] })
            break
          default:
            break
        }
      })

      return arr
    },
  },

  methods: {
    ...mapActions('directories', ['getLocationDirectory', 'getEventPartTypeDirectory']),

    async getFilterParams() {
      this.getLocationDirectory()
      this.getEventPartTypeDirectory()
    },

    setFilters() {
      this.$emit('setFilters', this.filters.getForAPI())
    },

    resetFilter(chip) {
      if (chip.key === 'dateTimeFrom') {
        this.filters.dateFrom = null
        this.filters.timeFrom = null
      } else if (chip.key === 'dateTimeTo') {
        this.filters.dateTo = null
        this.filters.timeTo = null
      } else {
        this.filters[chip.key] = null
      }
      this.setFilters()
    },
  },

  watch: {
    showFilter(val) {
      val && this.getFilterParams()
    },
  },
}
</script>
